import * as Types from '../../../../@types/graphql-types';

import gql from 'graphql-tag';
export type ResolveShift72SlugQueryVariables = Types.Exact<{
	input: Types.ResolveShift72SlugInput;
}>;

export type ResolveShift72SlugQuery = {
	__typename?: 'Query';
	resolveShift72Slug: { __typename?: 'ResolveShift72SlugPayload'; fullPath: string; jwEntityID: string };
};

export const ResolveShift72SlugDocument = gql`
	query ResolveShift72Slug($input: ResolveShift72SlugInput!) {
		resolveShift72Slug(input: $input) {
			fullPath
			jwEntityID
		}
	}
`;
